// Define randomShape globally
window.randomShape = function(top, left, width, height, blur) {
  return {
    top: top + 'px',
    left: left + 'px',
    width: width + 'px',
    height: height + 'px',
    filter: 'blur(' + blur + 'px)'
  };
};

// Define mq (Media Query helper) globally  
window.mq = {
  xsDown: '(max-width: 575.98px)',
  smDown: '(max-width: 767.98px)', 
  mdDown: '(max-width: 991.98px)',
  lgDown: '(max-width: 1199.98px)',
  xlDown: '(max-width: 1399.98px)',
  smUp: '(min-width: 576px)',
  mdUp: '(min-width: 768px)',
  lgUp: '(min-width: 992px)',
  xlUp: '(min-width: 1200px)',
  xxlUp: '(min-width: 1400px)'
};
